/**
 * RFC 7807 Problem Details fields returned by the API.
 */
export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  traceId?: string;
  errorCode?: string;
  retryAfter?: string;
  platformName?: string;
}

/**
 * Custom error class for API responses that carries the HTTP status code
 * and optional RFC 7807 Problem Details context.
 * Used to distinguish authorization errors (401/403) from other failures
 * so the global React Query error handler can show appropriate messages.
 */
export class ApiError extends Error {
  public readonly status: number;
  public readonly problemDetails?: ProblemDetails;

  constructor(status: number, message: string, problemDetails?: ProblemDetails) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.problemDetails = problemDetails;
  }

  get isUnauthorized(): boolean {
    return this.status === 401 || this.status === 403;
  }

  get isServiceUnavailable(): boolean {
    return this.status === 503;
  }

  get errorTitle(): string {
    return this.problemDetails?.title ?? this.message;
  }

  get errorDetail(): string | undefined {
    return this.problemDetails?.detail;
  }
}
